import { useRouter } from 'next/router';

import { useAdDetailsContext } from '../../../../../../contexts/AdDetailsContext';

import { fireToast } from '../../../../../../helpers/Toasts';
import { rg4js } from '../../../../../../helpers/raygun';
import { PAGE } from '../../../../../../helpers/pages';
import { pushToDataLayer } from '../../../../../../services/gtmService';
import { useGetWhatsAppLink } from './useGetWhatsAppLink';

const useContactDealershipBottomSheet = (args: { adId: number }) => {
  const { adId } = args;

  const { push } = useRouter();

  const { isContactSellerModalOpen, setIsContactSellerModalOpen } =
    useAdDetailsContext();

  const {
    data: cachedWhatsAppLink,
    refetch: getWhatsAppLink,
    isFetching,
  } = useGetWhatsAppLink(adId, { enabled: false });

  const onWhatsAppButtonClick = async () => {
    pushToDataLayer({ event: 'whatsapp_click' });

    if (cachedWhatsAppLink) {
      push(cachedWhatsAppLink);
      return;
    }

    try {
      const response = await getWhatsAppLink();

      if (response.error) {
        // Don't fire a toast, this is already handled in the React Query Wrapper
        rg4js('send', {
          error: response.error,
          customData: {
            pageName: PAGE.AD_DETAILS,
            functionName: 'onWhatsAppButtonClick',
          },
        });
        return;
      }

      if (!response.data) {
        throw new Error('No WhatsApp link found');
      }

      push(response.data);
    } catch (error) {
      rg4js('send', {
        error,
        customData: {
          pageName: PAGE.AD_DETAILS,
          functionName: 'onWhatsAppButtonClick',
        },
      });
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
    }
  };

  const closeContactSellerModal = () => setIsContactSellerModalOpen(false);

  return {
    isContactSellerModalOpen,
    onWhatsAppButtonClick,
    isLoading: isFetching,
    closeContactSellerModal,
  };
};

export { useContactDealershipBottomSheet };
